import { newsletter } from '@organisms/newsletter';

export const initFooterNewsletter = () => {
  if (!document.querySelector('.footer-columns')) {
    return;
  }

  const input = document.getElementById('newsletter_email_footer');
  newsletter('#form_newsletter_footer', input);
};
